import RBush from 'rbush';

import { getVisibleTiles } from '.';
import { IRBushItem } from '../../types/map';
import { getExtendedTileBBox } from '../tile';

interface IGetTilesToUpdateParams {
  rbushItems: IRBushItem[];
  bounds: [YMaps.TCoord, YMaps.TCoord];
  zoom: number;
  includePulseRadius: boolean;
  pulseRadius: number;
  includeShadow?: boolean;
}

export function getTilesToUpdate(params: IGetTilesToUpdateParams): YMaps.TTileNumber[] {
  const { rbushItems, zoom: zoomRaw, bounds, includeShadow, includePulseRadius, pulseRadius } = params;

  const sapling = new RBush();
  sapling.load(rbushItems);

  const zoom = Math.round(zoomRaw);
  const visibleTilesNumbers = getVisibleTiles(bounds, zoom);

  const tilesToUpdate: YMaps.TTileNumber[] = [];
  visibleTilesNumbers.forEach(tileNumber => {
    /**
     * @todo разработка в MNZ-700
     * Добавляем расширенную область поиска точек
     */
    const extendedTileBox = getExtendedTileBBox({
      tileNumber,
      zoom,
      includeShadow,
      includePulseRadius,
      pulseRadius,
    });

    if (sapling.collides(extendedTileBox)) {
      tilesToUpdate.push(tileNumber);
    }
  });

  return tilesToUpdate;
}
